import { api } from "./api";

export const damagesService = {
  list: async (params) => (await api.get("/admin/damages", { params })).data,
  get: async (id) => (await api.get(`/admin/damages/${id}`)).data,
  create: async (payload) => (await api.post("/admin/damages", payload)).data,
  update: async (id, payload) => (await api.patch(`/admin/damages/${id}`, payload)).data,
  remove: async (id) => (await api.delete(`/admin/damages/${id}`)).status,
};

export const adminOrdersService = {
  transition: async (id, payload) =>
    (await api.post(`/admin/orders/${id}/transition`, payload)).data,
  bulkAcknowledge: async (orderIds) =>
    (await api.post(`/admin/orders/bulk-acknowledge`, { order_ids: orderIds })).data,
};
